import axios from '@/axios';

const RESOURCE_NAME = '/needs-dashboard';

export default {
    getDashboardData() {
        return axios.get(`${RESOURCE_NAME}/get-dashboard-data`);
    },

    sendUnlockRequest(data) {
        return axios.post(`${RESOURCE_NAME}/send-unlock-request`, data)
    },

    sendFindMoreSolutionsRequest(data) {
        return axios.post(`${RESOURCE_NAME}/send-find-more-solutions-request`, data)
    },

    getNeedsList(type, filters) {
        return axios.post(`${RESOURCE_NAME}/get-dashboard-needs-list?type=${type}`, {filters});
    },
}
